import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Logger } from 'projects/common/src/app/classes';
import { AuthenticationService } from '../../services';

@Injectable({
  providedIn: 'root'
})
export class CanActiveAuthorizationModuleService extends Logger implements CanActivate {

  constructor(
    private authService: AuthenticationService,
    private router: Router
  ) {
    super();
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
      const urlSegments = route.url;
      let segment;
      if (Array.isArray(urlSegments) && urlSegments.length) {
        segment = urlSegments[0].path;
        // TODO revisar permisos de la sesión sobre el componente
        if (this.authService.isAuth()) {
          this.log(`Se permitió acceso para acceder al componente [${segment}]`);
          return true;
        } else {
          this.error(`No tiene permiso para acceder al componente [${segment}]`);
          this.router.navigate(['/login']);
        }

        return false;
      }
      return true;
  }
}
